import React from 'react';

export const MOTOR_CURRENCY_OPTIONS = [
  { value: 'USD', label: 'USD — Amerikan Doları' },
  { value: 'EUR', label: 'EUR — Euro' },
  { value: 'TRY', label: 'TRY — Türk Lirası' }
];

const FormSelect = React.memo(({
  label,
  value,
  onChange,
  options,
  hint = 'Seçeneklerden birini seçin',
  disabled = false,
  id,
  className = ''
}) => {
  const selectId = id || `select-${label?.replace(/\s+/g, '-').toLowerCase()}`;

  return (
    <div className={`form-group${className ? ` ${className}` : ''}`}>
      {label && <label htmlFor={selectId}>{label}</label>}
      <div className={`form-select-wrap${disabled ? ' is-disabled' : ''}`}>
        <select
          id={selectId}
          className="form-select"
          value={value}
          onChange={onChange}
          disabled={disabled}
        >
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <span className="form-select-chevron" aria-hidden="true">
          <i className="fas fa-chevron-down" />
        </span>
      </div>
      {hint && <span className="form-field-hint">{hint}</span>}
    </div>
  );
});

export default FormSelect;
